module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 4
// module chunks = 0